import React from 'react';
import Chart from 'chart.js/auto';
import { Bubble } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import Card from 'src/components/sharedComponents/Card/Card';
import CardHeader from 'src/components/sharedComponents/Card/CardHeader';
import CardBody from 'src/components/sharedComponents/Card/CardBody';

Chart.register(ChartDataLabels);

const MapValueCardGraph = ({
  title, height, width, data, classes,
}) => (
  <Card>
    <CardHeader color="customAuteco">
      {' '}
      <h4 className={classes.cardTitleWhite}>
        {' '}
        {title}
      </h4>
    </CardHeader>
    <CardBody>
      <Bubble
        height={height}
        width={width}
        data={data}
        options={{
          responsive: true,
          plugins: {
            legend: {
              title: {
                display: true,
                position: 'buttom',
              },
            },
          },
        }}
      />
    </CardBody>
  </Card>
);

export default MapValueCardGraph;
